











 











const node = {
  "kind": "InlineDataFragment",
  "name": "useSpotlightResults_meeting"
};

(node ).hash = "ed47139937dc8e41c24d4f2ea3966651";

export default node;
